/* eslint-disable arrow-body-style */
import React from 'react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { useNavigate } from 'react-router';
import Navigation from './navigation';
import { createApiInstance } from '../../config/apiConfig';
import Error from '../../modules/error/error';
import MainMenu from '../menus/mainMenu/mainMenu';
import './app.scss';
import { oktaAuthConfig } from '../../config/oktaConfig';

const oktaAuth = new OktaAuth(oktaAuthConfig.oidc);

function App() {
    createApiInstance();
    const navigate = useNavigate();
    const restoreOriginalUri = async(_oktaAuth, originalUri) => {
        navigate(toRelativeUrl(originalUri, window.location.origin), { replace: true });
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <div className="app">
                <div className="menu-wrapper">
                    <MainMenu oktaAuth={oktaAuth} />
                    <Error />
                    <div className="menu-wrapper-middle-column" id="resizeable-container">
                        <Navigation oktaAuth={oktaAuth} />
                    </div>
                </div>
            </div>
        </Security>
    );
}

export default App;
